import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import varibles from "@/assets/js/variables";

Vue.use(VueRouter);

// PERMISSIONS

const tokenGuard = (to, from, next) => {
  if (store.getters["user/hasToken"]) {
    if (
      !to.meta.canAccessRole ||
      (to.meta.canAccessRole &&
        to.meta.canAccessRole.includes(
          store.getters["user/getActiveUser"].role
        ))
    ) {
      next();
    } else {
      next("/");
    }
  } else if (!to.meta.needPermission) {
    next();
  } else {
    next("/login");
  }
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("@/views/Layout/MainLayouts/LoggedInLayout"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/users",
          name: "Users",
          component: () => import("@/views/Users"),
          meta: {
            canAccessRole: [varibles.roleName.ADMIN],
            needPermission: true,
            pageTitle: "router.pageTitle.users"
          }
        },
        {
          path: "/partners",
          name: "Partners",
          component: () => import("@/views/Partners"),
          meta: {
            canAccessRole: [varibles.roleName.ADMIN],
            needPermission: true,
            pageTitle: "router.pageTitle.partners"
          }
        },
        {
          path: "/movements",
          name: "Movements",
          component: () => import("@/views/MovementsScreen"),
          meta: {
            canAccessRole: [varibles.roleName.ADMIN],
            needPermission: true,
            pageTitle: "router.pageTitle.movements"
          }
        },
        {
          path: "/delivery",
          name: "Delivery Screen",
          component: () => import("@/views/DeliveryScreen"),
          meta: {
            canAccessRole: [
              varibles.roleName.STOREMAN,
              varibles.roleName.DRIVER,
              varibles.roleName.ADMIN
            ],
            needPermission: true,
            pageTitle: "router.pageTitle.delivery"
          }
        },
        {
          path: "/wash",
          name: "Wash Screen",
          component: () => import("@/views/WashScreen"),
          meta: {
            canAccessRole: [
              varibles.roleName.STOREMAN,
              varibles.roleName.ADMIN
            ],
            needPermission: true,
            pageTitle: "router.pageTitle.wash"
          }
        },
        {
          path: "/byPartner",
          name: "BoxesByPartner",
          component: () => import("@/views/BoxesByPartner"),
          meta: {
            canAccessRole: [
              varibles.roleName.STOREMAN,
              varibles.roleName.DRIVER,
              varibles.roleName.ADMIN
            ],
            needPermission: true,
            pageTitle: "router.pageTitle.byPartner"
          }
        },
        {
          path: "/",
          name: "Store",
          component: () => import("@/views/StoreScreen"),
          meta: {
            canAccessRole: [
              varibles.roleName.STOREMAN,
              varibles.roleName.DRIVER,
              varibles.roleName.ADMIN
            ],
            needPermission: true,
            pageTitle: "router.pageTitle.store"
          }
        },
        {
          path: "/profile",
          name: "Profile",
          component: () => import("@/views/ProfileScreen"),
          meta: {
            canAccessRole: [
              varibles.roleName.STOREMAN,
              varibles.roleName.DRIVER,
              varibles.roleName.ADMIN
            ],
            needPermission: true,
            pageTitle: "router.pageTitle.profile"
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/views/Layout/MainLayouts/LoggedOutLayout"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "login",
          component: () => import("@/views/Auth/Login"),
          meta: {
            canAccessRole: [
              varibles.roleName.STOREMAN,
              varibles.roleName.DRIVER,
              varibles.roleName.ADMIN
            ],
            needPermission: false
          }
        },
        {
          path: "/error-404",
          name: "page-error-404",
          component: () => import("@/views/Pages/Error404"),
          meta: {
            canAccessRole: [
              varibles.roleName.DRIVER,
              varibles.roleName.STOREMAN,
              varibles.roleName.ADMIN
            ],
            needPermission: false
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/error-404",
      meta: {
        needPermission: false
      }
    }
  ]
});
router.beforeEach(tokenGuard);

export default router;
